jQuery(document).ready(function() {
    jQuery('html,body').on('click','.notification-header', function (event) {
		if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)){
			jQuery('.news-slider').slick('slickPause');
			jQuery('.autoplay').removeClass('play').addClass('pause');
		}
        event.stopPropagation();
		jQuery('.notification-item .notification-content').slideUp();
		jQuery('.notification-item').removeClass('active');
	
		if(jQuery(this).closest('.notification-item').find('.notification-content').is(':visible')){
			jQuery(this).closest('.notification-item').removeClass('active');
			jQuery(this).closest('.notification-item').find('.notification-content').slideUp();
		} 
		else{
			jQuery(this).closest('.notification-item').addClass('active');
			jQuery(this).closest('.notification-item').find('.notification-content').slideDown();
		}
		
	});
	
	//notification hide based on cookie js
	/* if(jQuery('.notification-item').length > 0){
		jQuery('.notification-item').show();
	}
	
	if(jQuery('.notification-remove-btn').length > 0){
		jQuery('.notification-remove-btn').on('click',function(){
			var notification_id = jQuery(this).attr('id');
			jQuery('.notification-item-'+notification_id).hide();
			var date = new Date();
			date.setTime(date.getTime() + 10 * 24 * 60 * 60 * 1000);
			if (typeof jQuery.cookie('notification-hide-cookie-ids') === 'undefined'){
				jQuery.cookie("notification-hide-cookie-ids", notification_id, { expires : date });
			} else {
				var storednotificationids = jQuery.cookie('notification-hide-cookie-ids');
				jQuery.cookie("notification-hide-cookie-ids", storednotificationids+'|'+notification_id, { expires : date });
			}
		});
	}
	if (typeof jQuery.cookie('notification-hide-cookie-ids') === 'undefined'){
		return false;
	}
	else{
		var hidenotificationids = jQuery.cookie('notification-hide-cookie-ids');
		var arraynotificationids = hidenotificationids.split('|');
		var i;
		for(i=0; i < arraynotificationids.length; i++ ){
			jQuery('.notification-item-'+arraynotificationids[i]).hide();
		}
	} */
	
}); //Document Ready End
